var e = e || {},
    stigefabrik = {},
    ga = {};
( function () {
    'use strict';

    e.newsletterpopup.form.emailMarketing = function ( jForm ) {
        var response = jQuery( '.js-e-newsletter-comfirm-msg' ).html();
        jQuery.ajax( {
            type: 'POST',
            url: '/',
            data: jForm.serialize(),
            beforeSend: function () {
                e.newsletterpopup.form.loading( jForm );
            },
            success: function () {
                e.newsletterpopup.success( response );
                stigefabrik.newsletterpopupgatracking();
            }
        } );
        return false;
    };
    stigefabrik.newsletterpopupgatracking = function () {
        ga('send', 'event', 'Nyhedsbrevstilmelding', 'Popup');
    };

    e.ecom.variants.setVariantDetails = function ( jVariantForm, productId, variantComboId ) {
        var variant = e.ecom.variants.combos[ productId ][ variantComboId ],
            variantInStock = parseInt( variant.ProductStock, 10 ) > 0,
            jVariantImage = jVariantForm.find( '.js-e-image' );
        jVariantImage.attr( 'href', e.dw.buildImageURL( '/Files/Images/ecom/Products/product-images/' + variant.ProductNumber + '.jpg', '1200', 'auto' ) );
        jVariantImage.attr( 'src', e.dw.buildImageURL( '/Files/Images/ecom/Products/product-images/' + variant.ProductNumber + '.jpg', 'auto', jVariantImage.width() ) );
        jVariantForm.find( '.js-e-number' ).html( variant.ProductNumber );
        e.ecom.updatePrice( jVariantForm );
        jVariantForm.find( '.js-e-stock-in' ).toggle( variantInStock === true );
        jVariantForm.find( '.js-e-stock-out' ).toggle( variantInStock === false );
        jVariantForm.find( '.js-e-stock-text' ).text( variant.ProductStockStateText );
        jVariantForm.find( '.js-e-price-with-vat' ).text( variant.ProductPriceWithVat );
        jVariantForm.find( '.js-e-stock-deliverytext' ).text( variant.ProductStockDeliveryText );
    };

}() );
